import Service from "./Service"

class SubStorageService extends Service {

    findById = (id) => this.get(`/sub-storages/${id}`)

    search = (queryParams) => this.getWithParams("/sub-storages", queryParams)

    createSubStorage = (requestBody) => this.post("/sub-storages", requestBody)

    updateSubStorage = (subStorageId, requestBody) => this.patch(`/sub-storages/${subStorageId}`, requestBody)

    deleteSubStorage = (subStorageId) => this.del(`/sub-storages/${subStorageId}`)
}

const subStorageService = new SubStorageService()
export default subStorageService